import axios from "@/plugins/axios";

let url = (data) => "/api/v1/mes/boms/excel".interpolate(data);

export const excel = {
    post(file) {
        var headers = { "Content-Type": "multipart/form-data" };
        var formData = new FormData();
        formData.append("file", file);
        return axios.post(url, formData, { headers }).then((result) => result.data);
    },
};

export default excel;
